module.exports = __webpack_public_path__ + "img/moban1.101f561c.svg";